/**
 * Created by spepa on 22.06.2023
 */

const Map2dFences = {};

Map2dFences.createFences = function () {
    const map = Map2d.currentMap;

    if (bundles.fence_outer) {
        Map2dFences.createOuterFence();
    }

    for (const name in map.regions) {
        if (name.startsWith("fence_")) {
            BorderRenderer.place(
                map.regions[name].positions,
                Map2dFences.imagePlacement,
                { regionName: name }
            );
        }
    }

    Map2dFences.AutoCreateRegions(map);
};

Map2dFences.imagePlacement = function (borders, cell, options) {
    const regionName = options.regionName;
    const isOuter = regionName === "fence_outer";
    borders.push({ name: "floor" });

    const isFogRegion = Map2d.currentMap.fogs.getFogRegions().includes(regionName) || isOuter;
    const fogEvents = ["open", "initialized"];

    borders.forEach((border) => {
        const borderName = border.name;
        const decoratorCode = Map2dFences.getDecoratorCode(borderName, regionName);
        if (!Map2dDecoratorView.getJson({ code: decoratorCode })) {
            return;
        }

        let zOrder;
        if (border.name !== "floor") {
            const isUpperBorder = ["up", "right", "up_right"].includes(borderName);
            zOrder = isUpperBorder ? -10 : 10;
            if (isOuter) {
                zOrder = isUpperBorder ? -11 : 11;
            }
        }

        const layer = borderName === "floor" ? Map2d.ABOVE_GROUND : Map2d.LAYER_UNITS;

        const fence = new Map2dDecorator({
            code: decoratorCode,
            regionName,
            borderName,
            x: cell.x,
            y: cell.y,
            layer,
            zOrder,
            dynamic: true
        });

        if (isFogRegion && !cleverapps.config.editorMode) {
            fogEvents.forEach((event) => {
                Map2d.currentMap.fogs.on(event, () => Map2dFences.onFogOpened(fence));
            });
        }

        Map2d.currentMap.decorators.addDecorator(cell.x, cell.y, fence);
    });
};

Map2dFences.createOuterFence = function () {
    const map = Map2d.currentMap;
    let unitedRegion = [];
    for (const name in map.regions) {
        if (name.startsWith("fence_")) {
            unitedRegion = unitedRegion.concat(map.regions[name].positions);
        }
    }
   
    BorderRenderer.place(
        unitedRegion,
        Map2dFences.imagePlacement,
        { regionName: "fence_outer" }
    );
};

Map2dFences.onFogOpened = function (fence) {
    const borderName = fence.borderName;
    const border = BorderRenderer.BORDERS[borderName];

    if (!border || border === "floor") {
        return;
    }

    fence.setVisible(true);

    let needShort = false;
    let needHide = false;

    const checkShort = (dir) => Map2dFences.needShortAnimation(fence, dir);

    if (BorderRenderer.isSide(borderName)) {
        needShort = checkShort(borderName);
    }

    if (BorderRenderer.isOutCorner(borderName)) {
        const [dir1, dir2] = borderName.split("_");
        const short1 = checkShort(dir1);
        const short2 = checkShort(dir2);
        needShort = short1 && short2;
        if (short1 !== short2) {
            needHide = true;
        }
    }

    if (BorderRenderer.isInnerCorner(borderName)) {
        const dir1 = borderName.split("_")[1];
        const dir2 = borderName.replace("inner_", "");
        const short1 = checkShort(dir1);
        const short2 = checkShort(dir2);
        needShort = short1 && short2;
        needHide = short1 !== short2;
    }

    if (needShort) {
        fence.setAnimation("idle_short");
    } else {
        fence.setAnimation("idle");
    }

    fence.setVisible(!needHide);
};

Map2dFences.needShortAnimation = function (decorator, checkedDirection) {
    const map = Map2d.currentMap;

    if (map.getFog(decorator.x, decorator.y)) {
        return false;
    }

    if (["up", "right"].includes(checkedDirection)) {
        const neighborFog = BorderRenderer.getNeighbor(decorator.x, decorator.y, checkedDirection);
        return map.isGround(neighborFog.x, neighborFog.y) && !map.getFog(neighborFog.x, neighborFog.y);
    }

    return true;
};

Map2dFences.getDecoratorCode = function (imageName, regionName) {
    let bundle = regionName;
    if (!bundles[regionName]) {
        bundle = "fence_common";
    }
    const url = `${bundle}_${imageName}`;
    return `${bundle}#${url}`;
};

Map2dFences.getFencesNames = function () {
    const fences = [];
    for (const region in Map2d.currentMap.regions) {
        if (region.startsWith("fence_")) {
            fences.push(region);
        }
    }
    return fences;
};

Map2dFences.AutoCreateRegions = function (map) {
    Object.keys(bundles).forEach((name) => {
        if (name.startsWith("fence_") && !map.regions[name]) {
            if (bundles[name].injectTo && bundles[name].injectTo.includes(Map2d.getUnitsTexture(map.unitsSkin))) {
                map.regions[name] = { positions: [] };
            }
        }
    });
};